import { authorizedApiClient } from "./config";

export enum GlobalSearchTypes {
  USERS = "users",
  ACCOUNTS = "accounts",
  VIEWS = "views"
}

interface GlobalSearchParams {
  workspace_identifier: string;
  search_query: string;
  object_type?: GlobalSearchTypes | null;
  limit?: number;
  offset?: number;
}

interface SearchResult {
  external_id: string;
  identifier: string;
  avatar_url: string | null;
  object_type?: string; // Added for views to determine which icon to use
}

interface GlobalSearchResponse {
  results: {
    accounts?: SearchResult[];
    contacts?: SearchResult[];
    views?: SearchResult[];
  };
}

export const getGlobalSearch = ({
  workspace_identifier,
  search_query,
  object_type = null,
  limit = 20,
  offset = 0
}: GlobalSearchParams) => authorizedApiClient.post<GlobalSearchResponse>(`/${workspace_identifier}/utils/global_search`, {
  search_query,
  object_type,
  limit,
  offset
});
